import type { StatusTone } from '@norvix/ui';
import { formatExactMinorUnits } from '@norvix/utils';

import type { CurrencyPosition, TransferMode, TransferStatus } from '../../api/commission-transfers.api.js';

/** Exact cents → "1,234.56 EUR". Null shows as a dash, never as zero. */
export function centsLabel(cents: string | null, currency: string): string {
  return cents === null ? '—' : `${formatExactMinorUnits(BigInt(cents), currency, true)} ${currency}`;
}

export const STATUS_LABEL: Readonly<Record<TransferStatus, string>> = {
  CALCULATED: 'Calculated only',
  SUBMITTED: 'In transfer',
  EXECUTION_UNKNOWN: 'Outcome unknown — resolve',
  SETTLED: 'Transferred',
  FAILED: 'Failed',
  SKIPPED_GUARD: 'Blocked by funds guard',
};

export const STATUS_TONE: Readonly<Record<TransferStatus, StatusTone>> = {
  CALCULATED: 'info',
  SUBMITTED: 'warning',
  EXECUTION_UNKNOWN: 'error',
  SETTLED: 'success',
  FAILED: 'error',
  SKIPPED_GUARD: 'error',
};

export const MODE_LABEL: Readonly<Record<TransferMode, string>> = {
  OFF: 'Off',
  CALCULATE_ONLY: 'Calculate only',
  LIVE: 'Live',
};

export function dateTimeUtc(iso: string): string {
  return `${iso.slice(0, 10)} ${iso.slice(11, 16)} UTC`;
}

/** The position card's warning for voided commissions already moved; null when there are none. */
export function voidedAfterTransferNotice(voided: CurrencyPosition['voidedAfterTransfer'], currency: string): string | null {
  if (voided.count === 0) return null;
  const subject = voided.count === 1 ? 'voided commission was' : 'voided commissions were';
  return `${String(voided.count)} ${subject} already transferred (${centsLabel(voided.totalCents, currency)}). `
    + 'They are not netted automatically; move the amount back to the client-money account by hand.';
}
